import { makeStyles,useTheme } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
  wrapper: {
    margin: '30px 0'
  },
  title: {
    margin: '0 0 19px',
    [theme.breakpoints.down('sm')]:{
      justifyContent: 'center',
      display: 'flex',
    }
  },
  row: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.down('sm')]:{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    }
  },
  input: {
    paddingBottom: '24px',
    width: '100%',
    [theme.breakpoints.down('sm')]:{
      width: '100%',
      display: 'flex'
    }
  }
}));
